export const allowFiles = [
    {
        id: 101,
        name: "Requerimiento inicial",
        tableName: "fiscalizacion",
        rules: [
            { name: "Requerimiento inicial", typeFile: "pdf", fileName: "req_inicial", required: true  },
        ],
        text:"Iniciado"
    },
    {
        id: 102,
        name: "Citatorio y acta de notificación",
        tableName: "fiscalizacion",
        rules: [
            { name: "Citatorio y acta de notificación", typeFile: "pdf", fileName: "citatorio_act_noti", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 103,
        name: "Otros requerimentos",
        tableName: "fiscalizacion",
        rules: [
            { name: "Otros requerimentos", typeFile: "pdf", fileName: "otros_req", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 104,
        name: "Invitación a conocer los hechos",
        tableName: "fiscalizacion",
        rules: [
            { name: "Invitación a conocer los hechos", typeFile: "pdf", fileName: "inv_a_conocer_hechos", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 105,
        name: "Oficio de observaciones",
        tableName: "fiscalizacion",
        rules: [
            { name: "Oficio de observaciones", typeFile: "pdf", fileName: "ofc_observaciones", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 106,
        name: "Escrito de contestación",
        tableName: "fiscalizacion",
        rules: [
            { name: "Escrito de contestación", typeFile: "pdf", fileName: "esc_contestacion", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 107,
        name: "Determinante credito",
        tableName: "fiscalizacion",
        rules: [
            { name: "Determinante credito", typeFile: "pdf", fileName: "det_cred", required: true  },
        ],
        text:"Concluido"
    },
    {
        id: 108,
        name: "Escrito de cumplimiento",
        tableName: "fiscalizacion",
        rules: [
            { name: "Escrito de cumplimiento", typeFile: "pdf", fileName: "esc_cump", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 109,
        name: "Otro",
        tableName: "fiscalizacion",
        rules: [
            { name: "Otro", typeFile: "pdf", fileName: "other", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 110,
        name: "Orden de visita",
        tableName: "fiscalizacion",
        rules: [
            { name: "Orden de visita", typeFile: "pdf", fileName: "orden_visita", required: true  },
        ],
        text:"Iniciado"
    },
    {
        id: 111,
        name: "Acta de inicio",
        tableName: "fiscalizacion",
        rules: [
            { name: "Acta de inicio", typeFile: "pdf", fileName: "acta_inicio", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 112,
        name: "Actas parciales",
        tableName: "fiscalizacion",
        rules: [
            { name: "Actas parciales", typeFile: "pdf", fileName: "actas_parc", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 113,
        name: "Ultima acta parcial",
        tableName: "fiscalizacion",
        rules: [
            { name: "Ultima acta parcial", typeFile: "pdf", fileName: "ult_acta_parc", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 114,
        name: "Acta final",
        tableName: "fiscalizacion",
        rules: [
            { name: "Acta final", typeFile: "pdf", fileName: "acta_final", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 201,
        name: "Acuse del recurso presentado",
        tableName: "recurso",
        rules: [
            { name: "Acuse del recurso presentado", typeFile: "pdf", fileName: "acuse_rec_pres", required: true  },
        ],
        text:"Iniciado"
    },
    {
        id: 202,
        name: "Acuerdo de requemimiento",
        tableName: "recurso",
        rules: [
            { name: "Acuerdo de requemimiento", typeFile: "pdf", fileName: "citatorio_act_noti", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 203,
        name: "Acuerdo de admisión",
        tableName: "recurso",
        rules: [
            { name: "Acuerdo de admisión", typeFile: "pdf", fileName: "otros_req", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 204,
        name: "Acuse de cumplimiento",
        tableName: "recurso",
        rules: [
            { name: "Acuse de cumplimiento", typeFile: "pdf", fileName: "acuse_cump", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 205,
        name: "Recaida a recurso",
        tableName: "recurso",
        rules: [
            { name: "Recaida a recurso", typeFile: "pdf", fileName: "recaida_rec", required: true  },
        ],
        text:"Concluido"
    },
        {
        id: 301,
        name: "Acuse demanda presentada",
        tableName: "juicio",
        rules: [
            { name: "Acuse demanda presentada", typeFile: "pdf", fileName: "acuse_dem_pres", required: true  },
        ],
        text:"Iniciado"
    },
    {
        id: 302,
        name: "Acuse promoción presentada",
        tableName: "juicio",
        rules: [
            { name: "Acuse promoción presentada", typeFile: "pdf", fileName: "acuse_prom_pres", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 303,
        name: "Acuerdo de admisión",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de admisión", typeFile: "pdf", fileName: "acuerdo_adm", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 304,
        name: "Acuerdo de requerimiento",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de requerimiento", typeFile: "pdf", fileName: "acuerdo_req", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 305,
        name: "Acuerdo de contestación de demanda",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de contestación de demanda", typeFile: "pdf", fileName: "acuerdo_const_demanda", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 306,
        name: "Acuerdo de ampliación",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de ampliación", typeFile: "pdf", fileName: "acuerdo_ampl", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 307,
        name: "Acuerdo de contestación a la ampliación",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de contestación a la ampliación", typeFile: "pdf", fileName: "acuerdo_const_a_ampl", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 308,
        name: "Acuerdo de alegatos",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de alegatos", typeFile: "pdf", fileName: "acuerdo_aleg", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 309,
        name: "Otros acuerdos",
        tableName: "juicio",
        rules: [
            { name: "Otros acuerdos", typeFile: "pdf", fileName: "other_ac", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 310,
        name: "Acuerdo de suspensión",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de suspensión", typeFile: "pdf", fileName: "acuerdo_susp", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 311,
        name: "Sentencia de suspención",
        tableName: "juicio",
        rules: [
            { name: "Sentencia de suspención", typeFile: "pdf", fileName: "sent_susp", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 312,
        name: "Sentencia definitiva",
        tableName: "juicio",
        rules: [
            { name: "Sentencia definitiva", typeFile: "pdf", fileName: "sent_def", required: true  },
        ],
        text:"Concluido"
    },
    {
        id: 313,
        name: "Acuerdo de firmeza",
        tableName: "juicio",
        rules: [
            { name: "Acuerdo de firmeza", typeFile: "pdf", fileName: "acdo_firmeza", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 314,
        name: "Otras sentencias",
        tableName: "juicio",
        rules: [
            { name: "Otras sentencias", typeFile: "pdf", fileName: "other_sent", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 401,
        name: "Contrato de prestación de servicios",
        tableName: "contract",
        rules: [
            { name: "Contrato de prestación de servicios", typeFile: "png", fileName: "contrato", required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 501,
        name: "Cotización",
        tableName: "cotizacion",
        rules: [
            { name: "Cotización", typeFile: "png", fileName: "cotizacion",required: true  },
        ],
        text:"Revisión"
    },
    {
        id: 601,
        name: "Minutas",
        tableName: "minutas",
        rules: [
            { name: "Minutas", typeFile: "png", fileName: "minutas",required: true  },
        ],
        text:"Revisión"
    },
];
